import React from 'react';
import Icon from '../../../components/AppIcon';

const QuickActionCard = ({ title, description, icon, iconColor, onClick }) => {
  return (
    <button
      onClick={onClick}
      className="w-full bg-card border border-border rounded-lg p-6 hover:shadow-md hover:border-primary/50 transition-all duration-200 text-left group"
    >
      <div className="flex items-start space-x-4">
        <div className={`flex-shrink-0 w-12 h-12 rounded-lg flex items-center justify-center ${iconColor} group-hover:scale-110 transition-transform duration-200`}>
          <Icon name={icon} size={24} color="white" />
        </div>
        <div className="flex-1 min-w-0">
          <h3 className="text-base font-heading font-semibold text-foreground mb-1 group-hover:text-primary transition-colors duration-200">
            {title}
          </h3>
          <p className="text-sm text-muted-foreground line-clamp-2">
            {description}
          </p>
        </div>
        <Icon 
          name="ArrowRight" 
          size={20} 
          className="flex-shrink-0 text-muted-foreground group-hover:text-primary group-hover:translate-x-1 transition-all duration-200"
        />
      </div>
    </button>
  );
};

export default QuickActionCard;